import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FileInputEffects } from '@innogy/common-ui/forms';
import { EmobilitySharedModule } from '@innogy/emobility-shared';
import { provideBootstrapEffects } from '@innogy/utils-state';
import { EffectsModule } from '@ngrx/effects';
import { combineReducers, StoreModule } from '@ngrx/store';

import {
  addressEffects,
  addressProviders,
} from './installation-address-form.effects';
import { LeadFormSubmitEffects } from './lead-form/lead-form-submit.effects';
import { LeadFormEffects } from './lead-form/lead-form.effects';
import {
  leadFormReducers,
  leadFormSelectorKey,
} from './lead-form/lead-form.state';
import { LeadFormSmeSubmitEffects } from './lead-form/lead-form-sme-submit.effects';

@NgModule({
  imports: [
    EmobilitySharedModule,
    CommonModule,
    StoreModule.forFeature(
      leadFormSelectorKey,
      combineReducers(leadFormReducers)
    ),
    EffectsModule.forFeature([
      ...addressEffects,
      LeadFormEffects,
      FileInputEffects,
    ]),
  ],
  providers: [
    ...addressProviders,
    provideBootstrapEffects([LeadFormSubmitEffects, LeadFormSmeSubmitEffects]),
  ],
})
export class EmobilityLeadStoreModule {}
